<div class="dialog-content">
    <div class="dialog-content__title">
        <span (click)="toggle()" class="icon" [class.is-playing]="isPlaying">
            <i class="fas fa-volume-up"></i>
        </span>
        <span class="text">Dialoog</span>
    </div>
    <div class="dialog-content__container">
        <ng-content></ng-content>
    </div>
</div>
